import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";

const BLogDetails = () => {
    const { slug } = useParams();
    const [blog, setBlog] = useState(null);
    
    useEffect(() => {
        console.log("useEffect:", slug);
        if (!slug) return;
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_BLOG_DETAILS;
        console.log('AAS');
        axios.get(`${apiBaseUrl}${Url}${slug}`)
            .then(response => setBlog(response.data))
            .catch(error => console.error("Error fetching API", error));
    }, [slug]);

    const [popularBlogs, setPopularBlogs] = useState([]);
    useEffect(() => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_BLOG;
        axios.get(`${apiBaseUrl}${Url}`)
            .then(response => setPopularBlogs(response.data))
            .catch(error => console.error("Error fetching API", error));
    }, []);
    
    return (
        <main>
            <section className="blog-banner-area" id="blog">
                <div className="container h-100">
                    <div className="blog-banner">
                        <div className="text-center">
                            <h1>Blog Details</h1>
                            <nav aria-label="breadcrumb" className="banner-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link className="" to="/" >Home </Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link className="" to="/blog"> Blog</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page"> {blog?.title}</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>
            <section className="blog_area single-post-area py-80px">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 posts-list">
                            <div className="single-post row">
                                <div className="col-lg-12">
                                    <div className="feature-img">
                                        <img className="img-fluid" src={blog?.image} alt="" />
                                    </div>
                                </div>
                                <div className="12 col-md-12 blog_details">
                                    <h2>{blog?.title}</h2>
                                    <p className="excert">
                                        {blog?.long}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="blog_right_sidebar">
                                <aside className="single_sidebar_widget popular_post_widget">
                                    <h3 className="widget_title">Popular Posts</h3>
                                    {popularBlogs.map((blg, index) => {
                                        return (
                                            <div className="media post_item" key={index}>
                                                <img className={"w-25"} src={blg.image} alt={blg.title} />
                                                <div className="media-body">
                                                    <Link className={'nav-link'} to={`/blog/${blg.slug}`}>{blg.title}</Link>
                                                </div>
                                            </div>
                                        );
                                    })}
                                    <div className="br"></div>
                                </aside>
                                <aside className="single_sidebar_widget ads_widget">
                                    <a href="#">
                                        <img className="img-fluid my-2" src="img/home/explore4.png" alt="" />
                                        <img className="img-fluid" src="img/home/explore5.png" alt="" />
                                    </a>
                                    <div className="br"></div>
                                </aside>
                             
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default BLogDetails;